import type { IconData } from '@stacksjs/iconify-core'

export const sl4x3: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"#0000cd\" d=\"M0 320.3h640V480H0z\"/><path fill=\"#fff\" d=\"M0 160.7h640v159.6H0z\"/><path fill=\"#00cd00\" d=\"M0 0h640v160.7H0z\"/></g>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default sl4x3
